import { rem } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('icon');

export const iconStyles = css`
  :host {
    block-size: 1em;
    display: inline-block;
    inline-size: 1em;
  }

  :host(.embedded) {
    inset-block-start: 50%;
    inset-inline-end: ${rem(10)};
    position: absolute;
    transform: translateY(-50%);
  }

  :host(.embedded:not(.clickable)) {
    pointer-events: none;
  }

  :where(svg) {
    block-size: 100%;
    display: block;
    fill: currentColor;
    inline-size: 100%;
    overflow: visible;
  }
`;
